<template>
  <v-menu max-width="300" offset-overflow offset-x :nudge-width="200">
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon>{{ icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t(`$vuetify.map.requests.historyLog`) }}</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-timeline dense class="py-1 px-0">
        <v-timeline-item v-for="item in history" :key="item.id" :color="item.statusColor" fill-dot small
                         class="py-1 px-0">
          <v-row class="pt-1" no-gutters>
            <v-col>
              <strong>{{ $vuetify.lang.t(`$vuetify.map.requests.dataIterator.states.${item.status}`) }}</strong>
              <div class="text-caption">
                {{ item.formattedFileTimestamp }}
              </div>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card>

  </v-menu>
</template>

<script>
import { mdiHistory } from '@mdi/js'

export default {
  name: 'fileTimeline',
  props: {
    history: Array
  },
  data: () => ({
    menu: false,
    icon: mdiHistory
  })
}
</script>

<style scoped>

</style>
